// Tabs: <div data-tabs> mit <section class="tab-panel" data-tab="Titel">.
// Ohne dieses Skript stehen alle Bereiche untereinander. Der aktive Tab steht
// im URL-Anker, damit Links und Rücksprünge (z. B. nach "Kein Anbieter")
// direkt den richtigen Bereich öffnen.
export default function tabs() {
  document.querySelectorAll('[data-tabs]').forEach(function (container) {
    const panels = Array.from(container.children).filter(function (el) { return el.classList.contains('tab-panel'); });
    if (panels.length < 2) return;

    const bar = document.createElement('div');
    bar.className = 'tab-bar';
    bar.setAttribute('role', 'tablist');

    const tabs = panels.map(function (panel, i) {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'tab';
      tab.id = 'tab-' + panel.id;
      tab.textContent = panel.dataset.tab;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);

      tab.addEventListener('click', function () { show(i, true); });
      tab.addEventListener('keydown', function (e) {
        const target = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (target === undefined) return;
        e.preventDefault();
        const n = (target + tabs.length) % tabs.length;
        show(n, true);
        tabs[n].focus();
      });

      bar.appendChild(tab);
      return tab;
    });

    container.insertBefore(bar, container.firstChild);
    container.classList.add('tabs-active');

    function show(i, remember) {
      tabs.forEach(function (tab, k) {
        const active = k === i;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[k].hidden = !active;
      });
      // Schmale Bildschirme: die Leiste scrollt seitlich - der aktive Tab
      // soll sichtbar sein, ohne die Seite selbst zu verschieben.
      const tab = tabs[i];
      if (tab.offsetLeft < bar.scrollLeft || tab.offsetLeft + tab.offsetWidth > bar.scrollLeft + bar.clientWidth) {
        bar.scrollLeft = tab.offsetLeft - 16;
      }
      // replaceState statt location.hash: kein Sprung, kein Eintrag im Verlauf je Klick.
      if (remember) history.replaceState(null, '', '#' + panels[i].id);
    }

    // Anker auf ein Panel oder auf ein Element darin öffnet dessen Tab.
    function fromAnchor() {
      const id = decodeURIComponent(window.location.hash.slice(1));
      const el = id ? document.getElementById(id) : null;
      const i = el ? panels.findIndex(function (p) { return p === el || p.contains(el); }) : -1;
      return { i: i, el: el };
    }

    // Zeigt der Anker auf ein ganzes Panel, zur Tab-Leiste springen - sonst
    // lägen die Tabs außerhalb des Bildes. Zeigt er auf ein Element im Panel
    // (etwa eine Antwortgruppe), zu diesem Element: der Browser konnte nicht
    // selbst dorthin springen, solange das Panel verborgen war.
    function scrollToAnchor(anchor) {
      // Zeigt der Anker auf eine zugeklappte Zeile (<details>), aufklappen.
      if (anchor.el.tagName === 'DETAILS') anchor.el.open = true;
      const target = anchor.el === panels[anchor.i] ? bar : anchor.el;
      window.requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
    }

    const start = fromAnchor();
    show(start.i >= 0 ? start.i : 0, false);
    if (start.i >= 0) scrollToAnchor(start);
    window.addEventListener('hashchange', function () {
      const anchor = fromAnchor();
      if (anchor.i >= 0) { show(anchor.i, false); scrollToAnchor(anchor); }
    });

    // Tabs in einem Formular (Konfiguration): Ein ungültiges Pflichtfeld in
    // einem verborgenen Tab kann der Browser weder fokussieren noch anmahnen -
    // das Absenden scheiterte dann stumm. "invalid" bubbelt nicht, daher Capture.
    container.addEventListener('invalid', function (e) {
      const i = panels.findIndex(function (p) { return p.contains(e.target); });
      if (i >= 0 && panels[i].hidden) show(i, true);
    }, true);

    // Nach dem Speichern wieder im selben Tab landen: Der Anker im action-Ziel
    // bleibt auch über die Weiterleitung nach dem POST erhalten.
    const form = container.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        form.action = (form.getAttribute('action') || '').split('#')[0] + window.location.hash;
      });
    }
  });
}
